__turbopack_context__.v({
  "className": "n3o7CG_className",
  "variable": "n3o7CG_variable",
});
